<template>
  <div>
    <v-toolbar color="secondary" dark tabs>
      <v-toolbar-title>{{$tc('design.property', 2)}}</v-toolbar-title>
      <v-tabs
        v-model="tabs"
        centered
        color="secondary"
        slot="extension"
        slider-color="accent"
      >
        <v-tab
          :href="`#tab-magio${id}-general`"
          ripple
        >
          {{$t('general.general')}}
        </v-tab>
      </v-tabs>
    </v-toolbar>

    <v-card-text>
      <v-tabs-items v-model="tabs">
        <v-tab-item :value="`tab-magio${id}-general`">
          <v-layout row wrap>
            <v-flex xs12 pb-0>
              <h3><b>{{$t('design.position')}}</b></h3>
            </v-flex>
            <v-flex xs4 pt-1 pb-0>
              <v-text-field
                v-model.number="x"
                name="pos-x"
                label="X"
                id="pos-x"
                type="number"
                disabled
              ></v-text-field>
            </v-flex>
            <v-flex xs4 pt-1 pb-0>
              <v-text-field
                v-model.number="y"
                name="pos-y"
                label="Y"
                id="pos-y"
                type="number"
                disabled
              ></v-text-field>
            </v-flex>
            <v-flex xs4 pt-1 pb-0>
              <v-text-field
                v-model.number="r"
                name="rotation"
                label="Rotation"
                id="rotation"
                type="number"
                disabled
              ></v-text-field>
            </v-flex>

            <v-flex xs12 pt-1 pb-0>
              <v-text-field
                v-model.number="zIndex"
                name="z-index"
                :label="$t('design.zIndex')"
                id="z-index"
                type="number"
                min="0"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 pt-1 pb-0>
              <h3><b>{{$t('design.size')}}</b></h3>
            </v-flex>
            <v-flex xs6 pt-1 pb-0>
              <v-text-field
                v-model.number="w"
                name="size-w"
                :label="$t('design.width')"
                id="size-w"
                type="number"
                disabled
              ></v-text-field>
            </v-flex>
            <v-flex xs6 pt-1 pb-0>
              <v-text-field
                v-model.number="h"
                name="size-h"
                :label="$t('design.height')"
                id="size-h"
                type="number"
                disabled
              ></v-text-field>
            </v-flex>

<!-- ############## -->
            <v-flex xs12 pt-1 pb-0>
              <h3><b>{{$t('design.directorFlags')}}</b></h3>
            </v-flex>
            <DirectorFlagsPropertyPlugin v-bind:directorFlags.sync="directorFlags" />

            <v-flex xs12 pt-1 pb-0>
              <h3>{{$t('design.magioOptions')}}</h3>
            </v-flex>
            <v-flex xs12 pt-1 pb-0>
              <v-select
                v-model="channelId"
                name="channelId"
                label="Channel"
                data-vv-name=""
                item-text="name"
                item-value="channel_id"
                :items="magioChannels"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </div>
</template>

<script>
import axios from 'axios';
import { mapWidgets } from './WidgetPropertiesUtils';
import WidgetPropertiesMixin from './WidgetPropertiesMixin';
import DirectorFlagsPropertyPlugin from './DirectorFlagsPropertyPlugin.vue';

export default {
  mixins: [WidgetPropertiesMixin],
  components: { DirectorFlagsPropertyPlugin },
  computed: {
    ...mapWidgets(
      [
        {
          path: 'dataMagio',
          key: 'channelId',
        },
        {
          path: 'style',
          key: 'horizontalAlign',
        },
        {
          path: 'style',
          key: 'verticalAlign',
        },
        {
          path: 'style',
          key: 'zIndex',
        },
        {
          path: 'style',
          key: 'directorFlags',
        },
        {
          path: 'style',
          key: 'w',
        },
        {
          path: 'style',
          key: 'h',
        },
        {
          path: 'style',
          key: 'x',
        },
        {
          path: 'style',
          key: 'y',
        },
        {
          path: 'style',
          key: 'r',
        },
      ],
    ),
  },
  mounted() {
    this.getMagioChannels();
  },
  methods: {
    getMagioChannels() {
      const vm = this;

      axios.get(`${window.api_url}api/organization/magio/channels`, {
        params: {
          paginate: false,
        },
      })
        .then((response) => {
          vm.magioChannels = response.data.data;
        })
        .catch((error) => {
          vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
        });
    },
  },
  data() {
    return {
      tabs: null,
      magioChannels: [],
    };
  },
};
</script>

<style scoped>
input:disabled {
  color: rgba(0, 0, 0, 0.26) !important;
  -webkit-text-fill-color: rgba(0, 0, 0, 0.26) !important;
}
</style>
